import type { IconAsset } from "#lib/iconProvider.js";

const ICON_URL_REGEX = /^icon:\/\/(?<set>[^\s/]+)\/(?<name>[^\s/]+)$/;

export function parseIconUrl(url: string): IconAsset | undefined {
	const match = ICON_URL_REGEX.exec(url);
	if (!match || !match.groups?.name || !match.groups?.set) {
		return undefined;
	}
	return { iconSet: match.groups.set, icon: match.groups.name };
}

export const ICONS = [
	"carbon:radio-button-checked",
	"flowcode:qr-code",
	"flowcode:return-to-start",
	"flowcode:custom-chart-size-1x1",
	"flowcode:custom-chart-size-1x2",
	"flowcode:custom-chart-size-1x3",
	"flowcode:custom-chart-size-2x1",
	"flowcode:custom-chart-size-2x2",
	"flowcode:custom-chart-size-2x3",
	"flowcode:six-dots-vertical",
	"fluent:checkbox-checked-16-regular",
	"fluent:content-view-16-regular",
	"gg:poll",
	"gridicons:grid",
	"gridicons:heading-h1",
	"grommet-icons:select",
	"grommet-icons:validate",
	"heroicons-solid:exclamation-circle",
	"heroicons-solid:hand-thumb-down",
	"heroicons-solid:hand-thumb-up",
	"heroicons-solid:paper-airplane",
	"heroicons-solid:phone",
	"heroicons-solid:question-mark-circle",
	"heroicons:adjustments-vertical",
	"heroicons:archive-box",
	"heroicons:arrow-down-tray",
	"heroicons:arrow-down",
	"heroicons:arrow-left-on-rectangle",
	"heroicons:arrow-left",
	"heroicons:arrow-long-left",
	"heroicons:arrow-long-right",
	"heroicons:arrow-path",
	"heroicons:arrow-right-circle",
	"heroicons:arrow-right-on-rectangle",
	"heroicons:arrow-right",
	"heroicons:arrow-top-right-on-square",
	"heroicons:arrow-trending-down",
	"heroicons:arrow-trending-up",
	"heroicons:arrow-turn-down-right",
	"heroicons:arrow-up-tray",
	"heroicons:arrow-up",
	"heroicons:bars-2",
	"heroicons:bars-3-bottom-left",
	"heroicons:bars-3",
	"heroicons:beaker",
	"heroicons:bell",
	"heroicons:bolt",
	"heroicons:book-open",
	"heroicons:bookmark-square",
	"heroicons:building-office-2",
	"heroicons:building-storefront",
	"heroicons:calculator",
	"heroicons:calendar-days",
	"heroicons:chart-bar-square",
	"heroicons:chart-bar",
	"heroicons:chart-bar",
	"heroicons:chat-bubble-left-ellipsis",
	"heroicons:chat-bubble-left-right",
	"heroicons:check-circle",
	"heroicons:check",
	"heroicons:chevron-double-left",
	"heroicons:chevron-double-right",
	"heroicons:chevron-down",
	"heroicons:chevron-left",
	"heroicons:chevron-right",
	"heroicons:chevron-up-down",
	"heroicons:chevron-up",
	"heroicons:circle-stack",
	"heroicons:clipboard-document-check",
	"heroicons:clipboard-document-list",
	"heroicons:clipboard-document",
	"heroicons:clock",
	"heroicons:cloud-arrow-up",
	"heroicons:code-bracket-square",
	"heroicons:code-bracket",
	"heroicons:cog-6-tooth",
	"heroicons:cog-8-tooth-solid",
	"heroicons:credit-card",
	"heroicons:currency-dollar",
	"heroicons:cursor-arrow-rays-solid",
	"heroicons:cursor-arrow-ripple-solid",
	"heroicons:device-phone-mobile",
	"heroicons:document-duplicate",
	"heroicons:document-plus",
	"heroicons:document-text",
	"heroicons:document",
	"heroicons:ellipsis-horizontal",
	"heroicons:ellipsis-vertical",
	"heroicons:envelope",
	"heroicons:equals",
	"heroicons:exclamation-circle",
	"heroicons:exclamation-triangle",
	"heroicons:eye-slash",
	"heroicons:eye",
	"heroicons:folder-plus",
	"heroicons:folder",
	"heroicons:globe-alt",
	"heroicons:globe-americas",
	"heroicons:hand-raised",
	"heroicons:hashtag",
	"heroicons:heart-solid",
	"heroicons:heart",
	"heroicons:home",
	"heroicons:identification",
	"heroicons:information-circle",
	"heroicons:key",
	"heroicons:light-bulb",
	"heroicons:link",
	"heroicons:list-bullet",
	"heroicons:lock-closed",
	"heroicons:magnifying-glass",
	"heroicons:map-pin",
	"heroicons:map",
	"heroicons:megaphone",
	"heroicons:minus-circle",
	"heroicons:minus-small",
	"heroicons:minus",
	"heroicons:moon",
	"heroicons:newspaper",
	"heroicons:no-symbol",
	"heroicons:paint-brush",
	"heroicons:paper-airplane",
	"heroicons:pause",
	"heroicons:pencil-square",
	"heroicons:pencil",
	"heroicons:phone",
	"heroicons:photo",
	"heroicons:play",
	"heroicons:plus-circle",
	"heroicons:plus-small",
	"heroicons:plus",
	"heroicons:puzzle-piece",
	"heroicons:qr-code",
	"heroicons:question-mark-circle",
	"heroicons:queue-list",
	"heroicons:rectangle-group",
	"heroicons:rectangle-stack",
	"heroicons:rocket-launch",
	"heroicons:server",
	"heroicons:share",
	"heroicons:shield-check",
	"heroicons:shopping-cart",
	"heroicons:sparkles",
	"heroicons:squares-2x2",
	"heroicons:star-solid",
	"heroicons:star",
	"heroicons:stop-circle",
	"heroicons:sun",
	"heroicons:swatch",
	"heroicons:table-cells",
	"heroicons:tag",
	"heroicons:trash",
	"heroicons:trophy",
	"heroicons:user-circle-solid",
	"heroicons:user-circle",
	"heroicons:user-group",
	"heroicons:user-plus",
	"heroicons:user-solid",
	"heroicons:user",
	"heroicons:users",
	"heroicons:video-camera",
	"heroicons:window",
	"heroicons:wrench-screwdriver",
	"heroicons:x-circle",
	"heroicons:x-mark",
	"humbleicons:arrow-split",
	"material-symbols-light:bottom-drawer",
	"material-symbols-light:call-to-action-outline",
	"material-symbols-light:data-table-outline",
	"material-symbols-light:palette-outline",
	"material-symbols-light:scrollable-header",
	"material-symbols:arrow-back",
	"material-symbols:bed-outline",
	"material-symbols:circle-outline",
	"material-symbols:circle",
	"material-symbols:flowchart-outline-sharp",
	"material-symbols:folder",
	"material-symbols:image-outline",
	"material-symbols:insert-chart-outline",
	"material-symbols:list-alt-add-outline",
	"material-symbols:movie-outline",
	"material-symbols:picture-as-pdf-outline",
	"material-symbols:square-foot",
	"material-symbols:ssid-chart",
	"material-symbols:stacked-bar-chart",
	"material-symbols:text-fields",
	"mdi:apple",
	"mdi:arrow-u-left-top",
	"mdi:arrow-u-right-top",
	"mdi:bathtub-outline",
	"mdi:chart-box-outline",
	"mdi:clock-plus-outline",
	"mdi:code-braces",
	"mdi:contacts-outline",
	"mdi:discord",
	"mdi:facebook",
	"mdi:folder-move-outline",
	"mdi:format-align-center",
	"mdi:format-align-left",
	"mdi:format-align-right",
	"mdi:format-bold",
	"mdi:format-italic",
	"mdi:format-strikethrough",
	"mdi:format-underline",
	"mdi:history",
	"mdi:home-outline",
	"mdi:instagram",
	"mdi:linkedin",
	"mdi:redo-variant",
	"mdi:snapchat",
	"mdi:soundcloud",
	"mdi:spotify",
	"mdi:twitch",
	"mdi:undo-variant",
	"mdi:whatsapp",
	"mdi:youtube",
	"mingcute:dots-line",
	"mingcute:social-x-line",
	"mingcute:threads-line",
	"mingcute:tiktok-line",
	"octicon:filter-16",
	"ph:calendar-check",
	"ph:calendar-dots",
	"ph:calendar",
	"ph:cube",
	"ph:dots-six-vertical",
	"ph:path-light",
	"ph:image-broken",
	"ph:square",
	"ri:draft-line",
	"solar:mailbox-outline",
	"tabler:arrow-bar-to-up",
	"tabler:template",
];
